/* ==========================================================================
   MINTCASED — comportamiento comun
   1. Marca el primer accesorio disponible como "Recomendado".
   2. Aplica la clase .mintcased-slide-button a los CTA.
      (2) venia como <script> inline al final de layout/theme.liquid; se ha
      movido aqui para que se cachee y no se reenvie en cada peticion.
   ========================================================================== */

(() => {
  /* ---------------------------------------------------------------------
     1. Accesorio recomendado
     --------------------------------------------------------------------- */
  const SECTION_SELECTOR = '[data-cross-sells]';
  const ITEM_SELECTOR = '[data-cross-sell-item]';
  const CHECKBOX_SELECTOR = '[data-cross-sell]';
  const COPY_SELECTOR = '.mcp-accessories__copy';

  const LABELS = {
    en: 'Recommended',
    es: 'Recomendado',
    de: 'Empfohlen',
    fr: 'Recommandé',
    it: 'Consigliato',
    pt: 'Recomendado',
    nl: 'Aanbevolen',
  };

  const label = () => {
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return LABELS[lang] || LABELS.en;
  };

  const highlightFirst = (section) => {
    if (section.dataset.mcRecommended === 'true') return;
    section.dataset.mcRecommended = 'true';

    const item = [...section.querySelectorAll(ITEM_SELECTOR)].find((candidate) => {
      const checkbox = candidate.querySelector(CHECKBOX_SELECTOR);
      return checkbox && !checkbox.disabled;
    });
    if (!item) return;

    item.classList.add('is-recommended');

    const copy = item.querySelector(COPY_SELECTOR);
    if (!copy || copy.querySelector('.mcp-accessories__recommended')) return;

    const badge = document.createElement('span');
    badge.className = 'mcp-accessories__recommended';
    badge.textContent = label();
    copy.prepend(badge);
  };

  const scanAccessories = (root = document) => {
    if (root instanceof Element && root.matches(SECTION_SELECTOR)) highlightFirst(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll(SECTION_SELECTOR).forEach(highlightFirst);
  };

  /* ---------------------------------------------------------------------
     2. Animacion de los CTA
     --------------------------------------------------------------------- */
  const BUTTON_SELECTOR = [
    'button',
    'a.button',
    'a[class*="button"]',
    'a[class*="btn"]',
    '[role="button"][class*="button"]',
    '.mcvc__cta',
    '.custom-hero__button',
    '.sticky-cart-button',
    '.mcp-panel__add',
    '.mcp-panel__sticky-button',
    '.mcp-panel__notify-button',
    '.shopify-payment-button__button',
    '.product-form__submit',
    '.quick-add__submit',
  ].join(',');

  const EXCLUDED_SELECTOR = [
    '[aria-expanded]',
    '[aria-haspopup]',
    '[class*="icon"]',
    '[class*="quantity"]',
    '[class*="slider"]',
    '[class*="close"]',
    '[class*="search"]',
    '[class*="menu"]',
    '[class*="accordion"]',
    '[class*="sound"]',
  ].join(',');

  const EXCLUDED_ANCESTORS =
    '.header, .localization-form, .quantity, .slider-buttons, .skip-to-content-link';

  const decorateButton = (button) => {
    if (!(button instanceof HTMLElement)) return;
    if (button.matches(EXCLUDED_SELECTOR)) return;
    if (button.closest(EXCLUDED_ANCESTORS)) return;
    if (!button.textContent.trim()) return;

    button.classList.add('mintcased-slide-button');
  };

  const scanButtons = (root = document) => {
    if (root instanceof HTMLElement && root.matches(BUTTON_SELECTOR)) decorateButton(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(decorateButton);
  };

  /* ---------------------------------------------------------------------
     Arranque: un solo MutationObserver para las dos tareas.
     --------------------------------------------------------------------- */
  const scan = (root) => {
    scanAccessories(root);
    scanButtons(root);
  };

  const start = () => {
    scan(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();